import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SideBar from '../Components/SideBar';
import './support.css';
import SupportMobile from './support_mobile';
import { API_BASE_URL } from '../config';
export default function Support() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // تحديد دور المستخدم (من الـ state أو الـ localStorage)
  const role = location.state?.role || localStorage.getItem("role") || "doctor";
  
  const [tickets, setTickets] = useState([]);
  const [activeTicketId, setActiveTicketId] = useState(location.state?.ticketId || null);
  const [activeTicketDetails, setActiveTicketDetails] = useState(null);
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState("");
  const [loading, setLoading] = useState(true);
  
  const messagesEndRef = useRef(null);
  const chatInputRef = useRef(null); // المرجع الخاص بحقل الإدخال لتفعيل النقر على المربع الأزرق
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // النزول لأسفل المحادثة تلقائياً
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // 1. جلب قائمة التذاكر عند فتح الصفحة
  useEffect(() => {
    fetchTickets();
  }, []);

  // 2. جلب تفاصيل التذكرة (والرسائل) عند تغيير التذكرة النشطة
 // 2. جلب تفاصيل التذكرة وتحديث المحادثة تلقائياً كل 3 ثوانٍ
  useEffect(() => {
    if (activeTicketId) {
      // 1. جلب الرسائل فوراً بمجرد فتح التذكرة
      fetchTicketDetails(activeTicketId);
      
      // 2. إنشاء مؤقت (Interval) يجلب الرسائل كل 3 ثوانٍ
      const intervalId = setInterval(() => {
        fetchTicketDetails(activeTicketId);
      }, 10000); // 3000 تعني 3 ثوانٍ، يمكنك تقليلها إلى 2000 لسرعة أكبر

      // 3. تنظيف المؤقت عند الخروج من المحادثة أو تغيير التذكرة لمنع تسرب الذاكرة
      return () => clearInterval(intervalId);
      
    } else {
      setMessages([]);
    }
  }, [activeTicketId]);

 const fetchTickets = async () => {
    const token = localStorage.getItem("access_token");
    
    // 1. التحقق من وجود التوكن، إذا لم يوجد نطرده لصفحة تسجيل الدخول
    if (!token) {
      alert("يرجى تسجيل الدخول أولاً");
      navigate("/log_in"); 
      return;
    }

    try {
      const res = await fetch(`${API_BASE_URL}/support/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      // 2. التحقق مما إذا كان التوكن منتهي الصلاحية أو غير صالح (خطأ 401)
      if (res.status === 401) {
        alert("انتهت جلسة الدخول أو غير مصرح لك. يرجى تسجيل الدخول مجدداً.");
        localStorage.removeItem("access_token"); 
        localStorage.removeItem("role");
        navigate("/log_in");
        return;
      }

      if (res.ok) {
        const data = await res.json();
        const ticketsList = data.results ? data.results : data;
        setTickets(ticketsList);

        if (!activeTicketId && ticketsList.length > 0) {
          setActiveTicketId(ticketsList[0].id);
        }
      }
    } catch (error) {
      console.error("خطأ في جلب التذاكر:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTicketDetails = async (id) => {
    const token = localStorage.getItem("access_token");
    if (!token) return navigate("/log_in");

    try {
      const res = await fetch(`${API_BASE_URL}/support/${id}/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.status === 401) {
        navigate("/log_in");
        return;
      }

      if (res.ok) {
        const ticketData = await res.json();
        setActiveTicketDetails(ticketData);
        
        const ticketMessages = ticketData.messages || ticketData.supportmessage_set || [];
        
        const formattedMessages = ticketMessages.map((msg) => ({
          id: msg.id,
          text: msg.message,
          sender: determineSender(msg, ticketData, role),
          footer: new Date(msg.created_at).toLocaleString('ar-EG', { hour: 'numeric', minute: 'numeric', hour12: true })
        }));
        
        setMessages(formattedMessages);
      }
    } catch (error) {
      console.error("خطأ في جلب تفاصيل التذكرة:", error);
    }
  };

  const determineSender = (msg, ticket, currentRole) => {
    const msgUserId = typeof msg.user === 'object' ? msg.user.id : msg.user;
    const ticketUserId = typeof ticket.user === 'object' ? ticket.user.id : ticket.user;
    
    const isTicketOwner = (msgUserId === ticketUserId);

    if (currentRole === 'doctor' || currentRole === 'user') {
      return isTicketOwner ? 'user' : 'support'; 
    } else {
      return isTicketOwner ? 'support' : 'user'; 
    }
  };

 const handleSendMessage = async (e) => {
    e.preventDefault(); 
    if (inputText.trim() === "") return; 

    const token = localStorage.getItem("access_token");
    const messageToSend = inputText;
    
    setInputText(""); 

    const optimisticMessage = {
      id: Date.now(), 
      text: messageToSend,
      sender: "user", 
      footer: "جاري الإرسال..."
    };
    
    setMessages((prevMessages) => [...prevMessages, optimisticMessage]);

    try {
      if (activeTicketId) {
        const res = await fetch(`${API_BASE_URL}/support/${activeTicketId}/reply/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ message: messageToSend }),
        });

        if (res.ok) {
          fetchTicketDetails(activeTicketId); 
        } else {
          const errorData = await res.json();
          console.error("فشل الإرسال:", errorData);
          alert("حدث خطأ أثناء إرسال الرسالة، يرجى المحاولة لاحقاً.");
        }

      } else {
        const res = await fetch(`${API_BASE_URL}/support/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            subject: "طلب مساعدة من النظام",
            priority: "medium", 
            message: messageToSend 
          }),
        });

        if (res.ok) {
          const newTicket = await res.json();
          setActiveTicketId(newTicket.id); 
          fetchTickets(); 
        } else {
          const errorData = await res.json();
          console.error("فشل إنشاء التذكرة:", errorData);
          alert("فشل إنشاء تذكرة الدعم، تأكد من اتصالك بالسيرفر.");
        }
      }
    } catch (error) {
      console.error("خطأ في الاتصال بالشبكة:", error);
      alert("خطأ في الاتصال بالشبكة.");
    }
  };

  const handleResolveTicket = async () => {
    if (!activeTicketId) return;
    const token = localStorage.getItem("access_token");
    
    try {
      const res = await fetch(`${API_BASE_URL}/support/${activeTicketId}/resolve/`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        alert("تم إغلاق التذكرة بنجاح.");
        fetchTickets();
        fetchTicketDetails(activeTicketId);
      }
    } catch (error) {
      console.error("خطأ في إغلاق التذكرة:", error);
    }
  };

  if (loading) {
    return (
      <div className="support-container" dir="rtl">
        <SideBar role={role} />
        <h2 style={{ padding: '50px', margin: 'auto' }}>جاري تحميل البيانات...</h2>
      </div>
    );
  }
  if (isMobile) {
    return (
      <SupportMobile 
        role={role}
        tickets={tickets}
        activeTicketId={activeTicketId}
        setActiveTicketId={setActiveTicketId}
        activeTicketDetails={activeTicketDetails}
        messages={messages}
        inputText={inputText}
        setInputText={setInputText}
        handleSendMessage={handleSendMessage}
        handleResolveTicket={handleResolveTicket}
        messagesEndRef={messagesEndRef}
      />
    );
  }
  return (
    <div className="support-container" dir="rtl">
      
      <SideBar role={role} />

      <main className="support-main">
        <div className="support-watermark"></div>

        <div className="ticket-header" style={{ padding: '15px', background: 'rgba(255,255,255,0.9)', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <h3 style={{ margin: 0, color: '#2c3e50' }}>تذاكر الدعم الفني</h3>
            {tickets.length > 0 && (
              <select 
                value={activeTicketId || ""} 
                onChange={(e) => setActiveTicketId(e.target.value)}
                style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}
              >
                {tickets.map(t => (
                  <option key={t.id} value={t.id}>
                    {t.subject} - {new Date(t.created_at).toLocaleDateString()} {t.status === 'resolved' ? '(مغلقة)' : ''}
                  </option>
                ))}
              </select>
            )}
          </div>

          {role === 'admin' && activeTicketDetails && activeTicketDetails.status !== 'resolved' && (
            <button 
              onClick={handleResolveTicket}
              style={{ background: '#27ae60', color: 'white', padding: '8px 15px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}
            >
              <i className="fa-solid fa-check"></i> إغلاق التذكرة
            </button>
          )}

        </div>

        <div className="messages-area">
          {messages.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '50px', color: '#7f8c8d' }}>
              لا توجد رسائل سابقة. {role === 'doctor' ? 'اكتب رسالتك لفتح تذكرة جديدة.' : 'اختر تذكرة لعرض المحادثة.'}
            </div>
          ) : (
            messages.map((msg) => (
              <div 
                key={msg.id} 
                className={`message-wrapper ${msg.sender === 'user' ? 'message-user' : 'message-support'}`}
              >
                <div className={`message-bubble ${msg.sender === 'user' ? 'bubble-user' : 'bubble-support'}`}>
                  {msg.text}
                </div>
                
                <span className={`message-footer ${msg.sender === 'user' ? 'footer-user' : 'footer-support'}`}>
                  {msg.footer}
                </span>
              </div>
            ))
          )}
          <div ref={messagesEndRef} />
        </div>

        {/* منطقة إدخال الرسالة */}
        {/* منطقة إدخال الرسالة */}
        <div className="input-area">
          <form onSubmit={handleSendMessage} className="input-form">
            
            {/* استخدام label يغطي المساحة الزرقاء بالكامل هو الحل النهائي */}
            <label htmlFor="mainChatInput" className="chat-input-label">
              <input 
                id="mainChatInput"
                type="text"
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                placeholder="اكتب رسالتك هنا..."
                className="chat-input"
                disabled={activeTicketDetails && (activeTicketDetails.status === 'resolved' || activeTicketDetails.status === 'closed')}
              />
            </label>
            
            <button 
              type="submit" 
              className="send-button"
              disabled={activeTicketDetails && (activeTicketDetails.status === 'resolved' || activeTicketDetails.status === 'closed')}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transform: 'scaleX(-1)' }}>
                <line x1="22" y1="2" x2="11" y2="13"></line>
                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
              </svg>
            </button>
          </form>
          {activeTicketDetails && (activeTicketDetails.status === 'resolved' || activeTicketDetails.status === 'closed') && (
            <p style={{ textAlign: 'center', color: '#e74c3c', fontSize: '13px', marginTop: '10px' }}>
              هذه التذكرة مغلقة ولا يمكن الرد عليها.
            </p>
          )}
        </div>
      </main>
    </div>
  );
}